import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Form } from 'grab-ui';
import { Link } from 'react-router';
import _ from 'lodash';
import { UCD_ACTION_TYPES, UCD_RESOURCE_NAMES, UCD_ROUTES_LINK, TRIDENT_CAMPAIGN_TEMPLATE, INTERNAL_STATUS } from 'omega-rtc/constants/ucd';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { CREATE_JOURNEY_CAMPAIGN, UPDATE_JOURNEY_CAMPAIGN, GET_UCD_CAMPAIGN, GET_TRIDENT_CAMPAIGN, createJourneyCampaign, updateJourneyCampaign, getUCDProject, getUCDCampaign, getTridentCampaign } from 'omega-rtc/actions/ucd';
import JourneyBuilder from 'omega-rtc/components/journey-builder/Layout';
import JOURNEY_TEMPLATE_KEY_DATA from 'omega-rtc/components/journey-builder/utils/constants';
import CampaignApprovalRequestForm from 'omega-rtc/views/ucd/CampaignApprovalRequestForm';
import { hasJustSuccess, isRequestsPending } from 'omega-rtc/utils/request-state-utils';
import { Dimmer, Loader } from 'semantic-grab-ui';
import Toastr from 'omega-rtc/utils/toastr-util';
import openLinkIcon from 'img/open_link.svg';

type Props = {
  createTridentCampaignRequest: any,
  createCampaign: Function,
  updateCampaign: Function,
  projectID: string,
  campaignID: string,
  user: any,
  triggerFullView: Function,
  router: any,
}

type State = {

}

class CreateJourneyCampaign extends Component {
  props: Props;
  state: State;
  constructor(props: Props) {
    super(props);
    const templateKey = props.router.params.template;
    this.state = {
      formData: {},
      shouldRequestApproval: false,
      showApprovalRequestModal: false,
      templateKey,
      isEdit: _.isEmpty(templateKey),
    };
    const { projectID, campaignID, getCampaign, getProject, getTridentCampaign } = this.props;
    getCampaign(projectID, campaignID);
    getProject(projectID);

    if (this.state.isEdit) {
      getTridentCampaign(projectID, campaignID);
    }
  }

  componentDidMount() {
    this.props.triggerFullView(true);
  }

  componentWillUnmount() {
    this.props.triggerFullView(false);
  }

  componentDidUpdate(prevProps) {
    const { isEdit } = this.state;
    const prev = isEdit ? prevProps.updateTridentCampaignRequest : prevProps.createTridentCampaignRequest;
    const current = isEdit ? this.props.updateTridentCampaignRequest : this.props.createTridentCampaignRequest;

    if (hasJustSuccess(prev, current)) {
      Toastr.success(`Campaign has been successfully ${isEdit ? 'updated' : 'created'}`);
      if (this.state.shouldRequestApproval) {
        this.updateShowApprovalRequestModal(true);
      } else {
        this.props.router.push(
          UCD_ROUTES_LINK.CAMPAIGN_VIEW(this.props.projectID, this.props.campaignID),
        );
      }
    }
  }

  updateShowApprovalRequestModal(value) {
    this.setState({ showApprovalRequestModal: value });
  }

  handleSubmitForm = (data: any, shouldRequestApproval: boolean) => {
    const { projectID, campaignID, user } = this.props;
    const { isEdit } = this.state;
    // TODO: remove actions validation from trident so we don't have to add it here
    const actionFunc = isEdit ? this.props.updateCampaign : this.props.createCampaign;
    actionFunc(
      {
        user: user.email,
        campaign: {
          nodes: data,
          type: 'journey',
          templateType: TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney,
          owner: 'TARGETING',
        },
      },
      projectID,
      campaignID
    );

    if (shouldRequestApproval) {
      this.setState({ shouldRequestApproval });
    }
  }

  closeRequestApprovalModal = (e) => {
    e.preventDefault();
    this.setState({
      showApprovalRequestModal: false,
    });
  }

  goBack = () => {
    const { isEdit } = this.state;
    const { router, projectID, campaignID } = this.props;
    router.push(
      isEdit
        ? `/ucd/project/${projectID}/campaign/${campaignID}/view?/view?previousPageIsListing=true`
        : `/ucd/project/${projectID}/campaign/${campaignID}/trident/create?previousPageIsListing=true`,
    );
  }

  render() {
    const { templateKey, isEdit } = this.state;
    const { projectID, campaignID } = this.props;

    // When submitting the form and pending for Http Response
    if (isRequestsPending(this.props.createTridentCampaignRequest)) {
      return <Dimmer inverted active> <Loader /> </Dimmer>;
    }
    const { campaignView, tridentCampaignView } = this.props;
    let conditionDetails;
    let actionDetails;
    let segmentDetails;
    let hedwigDetails;

    if (campaignView !== undefined) {
      const {
        otherDetails,
      } = campaignView.campaign;
      conditionDetails = getOtherDetailItems(otherDetails, 'Condition', 'label');
      actionDetails = getOtherDetailItems(otherDetails, 'Action', 'label');
      segmentDetails = getOtherDetailItems(otherDetails, 'Segment', 'ID');
      hedwigDetails = getOtherDetailItems(otherDetails, 'Hedwig', 'ID');
    }
    const isShowApproval = !(isEdit && _.upperCase(_.get(campaignView, 'status')) === INTERNAL_STATUS.deactivated);
    const data = _.get(tridentCampaignView, 'campaign.nodes', JOURNEY_TEMPLATE_KEY_DATA[templateKey]);

    return (
      <div>
        <JourneyBuilder
          goBack={this.goBack}
          campaignView={this.props.campaignView}
          isView={false}
          data={data}
          isShowApproval={isShowApproval}
          handleSubmitForm={this.handleSubmitForm}
        />
        {this.state.showApprovalRequestModal && <CampaignApprovalRequestForm
          closeModal={this.closeRequestApprovalModal}
          campaignView={campaignView}
          conditionDetails={conditionDetails}
          actionDetails={actionDetails}
          segmentDetails={segmentDetails}
          hedwigDetails={hedwigDetails}
          getLinker={getLinker}
          editingUrl={`/ucd/project/${projectID}/campaign/${campaignID}/view?/view?previousPageIsListing=true`}
          onApprove={() => { this.props.router.push(UCD_ROUTES_LINK.CAMPAIGN_VIEW(this.props.projectID, this.props.campaignID)); }}
        />}
      </div>
    );
  }
}

const getOtherDetailItems = (otherDetails: object, title: string, propName: string) => {
  const otherDetailsItems = _.find(otherDetails, (item) => item.title === title);
  if (_.isEmpty(otherDetailsItems) || _.isEmpty(otherDetailsItems.items)) return [];

  const uniqueItems = otherDetailsItems.items.reduce((acc, item) => {
    if (!acc.some((uniqueItem) => uniqueItem[propName] === item[propName])) {
      acc.push(item);
    }
    return acc;
  }, []);

  return uniqueItems;
};

const getLinker = (text: string, url: string) => {
  return (
    <div className="linker">
      <Link to={url} target="_blank">
        <span>{text} </span><img src={openLinkIcon} height={'9px'} alt={''} />
      </Link>
    </div>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  const userPermissions = state.app.user.userPermissions;
  return {
    projectID: ownProps.params.entityID,
    campaignID: ownProps.params.campaignID,
    campaignView: state.ucd.campaignView,
    tridentCampaignView: state.ucd.tridentCampaignView,
    user: state.app.user,
    userPermissions,
    createTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(CREATE_JOURNEY_CAMPAIGN),
      {},
    ),
    updateTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(UPDATE_JOURNEY_CAMPAIGN),
      {},
    ),
    getCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_UCD_CAMPAIGN),
      {},
    ),
    getTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_TRIDENT_CAMPAIGN),
      {},
    ),
  };
};


const mapDispatchToProps = dispatch => ({
  createCampaign: (data, projectID, campaignID) => {
    dispatch(createJourneyCampaign(data, projectID, campaignID));
  },
  updateCampaign: (data, projectID, campaignID) => {
    dispatch(updateJourneyCampaign(data, projectID, campaignID));
  },
  getProject: projectID => {
    dispatch(getUCDProject(projectID));
  },
  getCampaign: (projectID, campaignID) => {
    dispatch(getUCDCampaign(projectID, campaignID));
  },
  getTridentCampaign: (projectID, campaignID) => {
    dispatch(getTridentCampaign(projectID, campaignID));
  },
});


const FormHOC = Form.create();
const TridentCampaignCreatePageAuthorized = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormHOC(CreateJourneyCampaign));


// page-level access control
const JourneyCampaignCreatePageComponent = (props: Props) => (
  <ShowIfAuthorized
    conditions={[
      {
        resource: UCD_RESOURCE_NAMES.campaign,
        action: UCD_ACTION_TYPES.create,
      },
    ]}
    unauthorizedContent={
      <Alert
        message="You don't have permission to create campaign"
        showIcon
        type="error"
      />
    }
  >
    <TridentCampaignCreatePageAuthorized {...props} />
  </ShowIfAuthorized>
);

export default JourneyCampaignCreatePageComponent;
